const LOADER_DIMENSIONS = {
  mobile: {
    margin: 0,
    modal: {
      width: '100%',
      height: '100%',
    },
    header: {
      height: 79,
    },
    footer: {
      height: 60,
    },
  },
  desktop: {
    margin: 0.13,
    modal: {
      width: '75%',
      height: '88%',
    },
    header: {
      height: 83,
    },
    footer: {
      height: 238,
    },
  },
};

const LoaderSizeMixin = {
  handleResize() {
    clearTimeout(this._resizeTimeout);
    this._resizeTimeout = setTimeout(() => {
      const {
        viewport: { height },
      } = this.props;
      const dimensions = this.loaderDimensions();
      const fixedHeight = dimensions.header.height + dimensions.footer.height;
      const modalWindowHeight =
        height - height * dimensions.margin - fixedHeight;

      this.setState({
        windowHeight: modalWindowHeight,
      });
      this.forceUpdate();
    }, 750);
  },

  loaderDimensions() {
    const {
      viewport: { isMobile },
    } = this.props;

    return isMobile ? LOADER_DIMENSIONS.mobile : LOADER_DIMENSIONS.desktop;
  },
};

export default LoaderSizeMixin;
